// @mui material components
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Link from "@mui/material/Link";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import Activity from "components/DigiHapi/Activity";

import { useSelector } from "react-redux";
import logoRounded from "assets/img/logo-rounded.png";

const contacts = [
	{
		icon: "phone",
		href: "tel:+33 (0)4 50 44 50 33",
		label: "+33 (0)4 50 44 50 33"
	},
	{
		icon: "email",
		href: "mailto:contact.digihapi@gmail.com}",
		label: "contact.digihapi@gmail.com"
	},
	{
		icon: "language",
		href: "https://www.digihapi.com",
		label: "https://www.digihapi.com",
		external: true
	}
];

export default function AboutPage(props) {
	const { isFetching, serverVersion } = useSelector(
		state => state.versionReducer
	);

	return (
		<Grid container spacing={3}>
			<Grid item xs={12} sm={6} lg={4}>
				{isFetching ? (
					<Activity />
				) : (
					<Card key="about">
						<MDBox display="flex" justifyContent="space-between" pt={1} px={2}>
							<MDBox
								variant="gradient"
								bgColor="light"
								borderRadius="xl"
								shadow="md"
								display="flex"
								justifyContent="center"
								alignItems="center"
								width="7rem"
								height="7rem"
								mt={-3}
							>
								<MDBox
									component="img"
									src={logoRounded}
									alt="O’Camping logo"
									height="100px"
								/>
							</MDBox>
							<MDBox textAlign="right" lineHeight={1.25}>
								<MDTypography variant="button" fontWeight="light" color="text">
									{"DigiHapi Administration"}
								</MDTypography>
								<MDTypography variant="h6" fontWeight="regular" mt={1}>
									{"Version client : "}
									<MDTypography component="span" variant="h6" color="primary">
										{require("../../../package.json").version}
									</MDTypography>
								</MDTypography>
								<MDTypography variant="h6" fontWeight="regular">
									{"Version serveur : "}
									<MDTypography component="span" variant="h6" color="primary">
										{serverVersion || ""}
									</MDTypography>
								</MDTypography>
							</MDBox>
						</MDBox>
						<Divider />
						<MDBox pb={2} px={2}>
							{contacts.map(({ icon, href, label, external }) => (
								<MDBox key={icon} display="flex" alignItems="center" py={0.5}>
									<MDBox color="text" mr={1} display="flex">
										<Icon color="inherit">{icon}</Icon>
									</MDBox>
									<Link
										href={href}
										{...(external
											? { target: "_blank", rel: "noopener noreferrer" }
											: {})}
									>
										<MDTypography variant="button" color="info">
											{label}
										</MDTypography>
									</Link>
								</MDBox>
							))}
						</MDBox>
					</Card>
				)}
			</Grid>
		</Grid>
	);
}
